import type { FC, ReactNode } from "react";
import * as s from "./ContentCard.module.scss";

type ContentCardProps = {
	image: ReactNode;
	title?: string;
	label?: string;
};

const ContentCard: FC<ContentCardProps> = ({ image, title, label }) => (
	<li className={s.contentCard}>
		{image && image}
		<div>
			{title && <h3>{title}</h3>}
			{label && <p>{label}</p>}
		</div>
	</li>
);

export default ContentCard;
